module.exports = __webpack_public_path__ + "img/wa_share.d7ade826.png";